import '../../App.scss'
import Fade from 'react-reveal/Fade';

export default function Footer() {


    return (
        <div className="Footer">
           <h2>© Ancient Historical Research Foundation 2021</h2>
        </div>
    );
}
